import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="owner";

export function queryByName(parameter) {
  return axios({
    url: `/ws/${moduleName}/queryByName`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectAllCard(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectAllCard`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function queryOwnerStatistics(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/queryOwnerStatistics`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function queryOwnerAll(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/queryOwnerAll`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function queryOwnerMansionById(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/queryOwnerMansionById`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectMansionInfo(mansionId) {
  console.log("params:", mansionId)
  return axios({
    url: `/ws/${moduleName}/selectMansionInfo/${mansionId}`,
    method: 'get',
  })
}

export function insert(parameter){
   console.log("data:",parameter)
   return axios({
     url: `/ws/${moduleName}`,
     method: 'post',
     data:parameter
   })
}

export function insertUpdateReason(parameter){
   console.log("data:",parameter)
   return axios({
     url: `/ws/${moduleName}/insertUpdateReason`,
     method: 'post',
     data:parameter
   })
}

export function updateMansionUpdate(parameter){
   console.log("data:",parameter)
   return axios({
     url: `/ws/${moduleName}/updateMansionUpdate`,
     method: 'post',
     data:parameter
   })
}

export function update(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}
export function selectOne(id) {
  console.log("id:", id)
  return axios({
    url: `/ws/${moduleName}/${id}`,
    method: 'get',
  })
}

export function queryByMansionId(mansionId) {
  return axios({
    url: `/ws/${moduleName}/queryByMansionId/${mansionId}`,
    method: 'get',
  })
}

export function getCooperationGradeUpdateInfo(id) {
  return axios({
    url: `/ws/${moduleName}/getCooperationGradeUpdateInfo/${id}`,
    method: 'get',
  })
}

export function getHisByMansion(parameter) {
  return axios({
    url: `/ws/${moduleName}/getHisByMansion`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


export function updateCooperationGrade(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/updateCooperationGrade`,
    method: 'put',
    data:parameter
  })
}


export function deleteOwnerById(ownerId) {
  return axios({
    url: `/ws/${moduleName}/deleteOwnerById/${ownerId}`,
    method: 'put'
  })
}


export default {
  insert,
  update,
  selectAll,
  updateMansionUpdate,
  queryOwnerAll,
  getHisByMansion,
  selectOne,
  queryByMansionId,
  selectMansionInfo,
  queryByName,
  getCooperationGradeUpdateInfo,
  updateCooperationGrade,
  insertUpdateReason,
  selectAllCard,
  queryOwnerMansionById,
  deleteOwnerById,
  queryOwnerStatistics
}